/* eslint-disable @typescript-eslint/naming-convention */
export class Profile {
  constructor(
    public firstName?: string,
    public lastName?: string,
    public type?: string,
    public password?: string,
    public password2?: string,
    public subscriber_number?: string,
    public birthdate?: string,
    public avatar_id?: number,
    public profil_id?: string,
    public nickname?: string,
    public schoolName?: string,
    public coupon?: string,
    public show?: any
  ) { }
}
